import React, { useState } from "react";
import { Container, Row, Col, Button, Card, ButtonGroup } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { Helmet } from "react-helmet";
import "./Detailing&coating.css";
import NavComplete from "./Component/Navbar1";
import Footer from "./Component/footer";
import LoadingImage from "./Component/Loadingimage";
import coating_img from "./Assets/coating-aftermath.jpg";

const Coatingpage = () => {
  const [activeTab, setActiveTab] = useState("detailing");

  const detailing_prices = [
    {
      title: "Gold Detailing",
      type: "Kenikmatan Kebesaran dalam Gold Detailing!",
      price: "Rp.500K",
      Bprice: "Rp.1.000K",
      steps: [
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Gold%20Detailing%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
    {
      title: "Silver Detailing",
      type: "Paket yang pas dikantong!",
      price: "Rp600K",
      Bprice: "Rp.1.200K",
      steps: [
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Silver%20Detailing%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
    {
      title: "Ultimate Detailing",
      type: "Detailing Terbaik yang Tidak Ada Duanya!",
      price: "Rp1.000K",
      Bprice: "Rp.2.500K",
      steps: [
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
        "Cleaning Vleg",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Ultimate%20Detailing%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
    {
      title: "Premium Detailing",
      type: "Kesempurnaan dalam Detailing Premium!",
      price: "Rp2.500K",
      Bprice: "Rp.3.000K",
      steps: [
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Premium%20Detailing%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
  ];

  const coating_prices = [
    {
      title: "Gold Coating",
      type: "Kenikmatan Kebesaran dalam Gold Coating!",
      price: "Rp.1.500K",
      Bprice: "Rp.3.000K",
      steps: [
        "2 Layer Coating",
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
        "Cleaning Velg",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Gold%20Coating%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
    {
      title: "Premium Coating",
      type: "Kesempurnaan dalam Coating Premium!",
      price: "Rp2.000K",
      Bprice: "Rp.4.000K",
      steps: [
        "2 Layer Coating 9H",
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
        "Cleaning Velg",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Premium%20Coating%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
    {
      title: "Ultimate Coating",
      type: "Paket Coating yang tidak mungkin mengecewakan!",
      price: "Rp.2.500K",
      Bprice: "Rp5.000K",
      steps: [
        "2 Layer Coating 9H",
        "Step 1 (Compound)",
        "Step 2 (Polish)",
        "Step 3 (Finish)",
        "Vacum Interior",
        "Cleaning Doortrim",
        "Cleaning Dashboard",
        "Cleaning Roof",
        "Cleaning Removing Seat and Carpet",
        "Cleaning Velg",
        "Velg Coating",
      ],
      massage: `https://api.whatsapp.com/send?phone=+6281399333280&&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Car%20Ultimate%20Coating%20di%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21`,
    },
  ];
  const metaData = {
    name: "description",
    content: "Your specific meta content for the article page goes here",
  };
  return (
    <>
      <NavComplete />
      <section className="welcome-section">
        <img src={coating_img} alt="car" className="welcome-car-image" />
        <Container>
          <Row>
            <Col className="container-1">
              <div className="welcome-content">
                <h1 className="blurry-text">
                  {localStorage.getItem("bahasa") === "ing"
                    ? "What is Detailing & Coating?"
                    : "Apa itu detailling & Coating?"}
                </h1>
                <p className="blurry-text">
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Vehicle Detailing & Coating for cars and motorcycles, also known as ceramic coating, is the process of applying a highly durable protective layer that provides extra protection against various external factors and enhances the vehicle's surface. This coating is composed of ceramic compounds that harden and form a transparent layer that adheres permanently to the vehicle's surface."
                    : "Detailing & Coating kendaraan untuk mobil dan motor (juga dikenal sebagai pelapisan keramik) adalah proses aplikasi lapisan pelindung yang sangat tahan terhadap berbagai faktor eksternal dan memberikan perlindungan ekstra terhadap permukaan kendaraan."}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="section-wraper">
        <section className="step-section">
          <div className="step-content">
            <h2 className="roleway">
              {localStorage.getItem("bahasa") === "ing"
                ? "Detailing & Coating process"
                : "Proses Detailing & Coating"}
            </h2>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "This Detailing & Coating consists of ceramic compounds that harden and form a transparent layer that adheres permanently to the vehicle's surface. The use of car and motorcycle coatings provides significant aesthetic benefits and protection for your vehicles. In addition to delivering long-lasting shine and beauty, coatings also help maintain the resale value of your vehicles and extend their lifespan. In the long run, the use of coatings will help keep your vehicles looking new and protected from damage caused by external factors.Coating has several key characteristics and benefits, including:"
                : "Detailing & Coating ini terdiri dari senyawa keramik yang mengeras dan membentuk lapisan transparan yang menempel secara permanen pada permukaan kendaraan.Penggunaan coating mobil dan motor memberikan manfaat estetika dan perlindungan yang signifikan bagi kendaraan Anda. Selain memberikan kilau dan keindahan yang tahan lama, coating juga menjaga nilai jual kendaraan dan memperpanjang masa pakainya. Dalam jangka panjang, penggunaan coating akan membantu menjaga kendaraan Anda tetap terlihat baru dan terlindungi dari kerusakan yang disebabkan oleh faktor eksternal. Coating memiliki beberapa karakteristik dan manfaat penting, antara lain:"}
            </p>
          </div>
        </section>
        {/* Step 1 Section */}
        <section className="step-section">
          <div className="step-image">
            <LoadingImage
              src="https://i.ibb.co.com/Wxqg3RS/Coating-image.jpg"
              alt="Step 1"
            // https://i.postimg.cc/kMHRf59N/Coating-image.jpg
            />
          </div>
          <div className="step-content">
            <h3 className="roleway">
              {localStorage.getItem("bahasa") === "ing"
                ? "Resistance to Scratches"
                : "Ketahanan Terhadap Goresan"}
            </h3>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "Detailing & Coating protective coatings can provide a high level of protection against scratches and minor marks that can occur on the surface of the vehicle due to contact with hard objects or abrasive materials."
                : "Lapisan pelindung Detailing & Coating mampu memberikan perlindungan yang tinggi terhadap goresan dan tanda-tanda kecil yang dapat terjadi pada permukaan kendaraan akibat kontak dengan benda keras atau bahan abrasif."}
            </p>
          </div>
        </section>

        {/* Step 2 Section */}
        <section className="step-section">
          <div className="step-image">
            <LoadingImage
              src="https://i.ibb.co.com/jkbG9MG/anti-gores.jpg"
              alt="Step 2"
            />
          </div>
          <div className="step-content">
            <h3 className="roleway">
              {localStorage.getItem("bahasa") === "ing"
                ? "Hydrophobic Effect"
                : "Efek Hidrofobik"}
            </h3>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "This coating exhibits a strong hydrophobic property, meaning that water and other liquids will bead up and easily flow off the vehicle's surface. This aids in keeping the vehicle clean and reducing the accumulation of dirt, water spots, or other substances."
                : "Detailing & Coating ini memiliki sifat hidrofobik yang kuat, artinya air dan cairan lainnya akan membentuk tetesan dan mengalir dengan mudah dari permukaan kendaraan. Ini membantu dalam menjaga kendaraan tetap bersih dan mengurangi penumpukan kotoran, noda air, atau zat-zat lainnya."}
            </p>
          </div>
        </section>

        {/* Step 3 Section */}
        <section className="step-section">
          <div className="step-image">
            <LoadingImage
              src="https://i.ibb.co.com/TPnDgDb/anti-uv.jpg"
              alt="Step 3"
            />
          </div>
          <div className="step-content">
            <h3 className="roleway">
              {localStorage.getItem("bahasa") === "ing"
                ? "Protection Against UV Rays"
                : "Perlindungan Terhadap Sinar UV"}
            </h3>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "Detailing & Coating protects the vehicle's surface from the harmful effects of ultraviolet (UV) rays. UV rays can cause premature aging, color changes, and damage to the vehicle's paint. With a protective layer, the vehicle is shielded from the adverse effects of UV rays."
                : "Detailing & Coating melindungi permukaan kendaraan dari efek buruk sinar ultraviolet (UV). Sinar UV dapat menyebabkan penuaan dini, perubahan warna, dan kerusakan pada cat kendaraan. Dengan lapisan pelindung, kendaraan terlindungi dari dampak negatif sinar UV."}
            </p>
          </div>
        </section>

        {/* Step 4 Section */}
        <section className="step-section">
          <div className="step-image">
            <LoadingImage
              src="https://i.ibb.co.com/d74Rr7P/washing-car.jpg"
              alt="Step 4"
            />
          </div>
          <div className="step-content">
            <h3 className="roleway">
              {localStorage.getItem("bahasa") === "ing"
                ? "Easy to Clean & Long-Lasting"
                : "Mudah Dalam Pembersihan & Tahan Lama"}
            </h3>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "Surfaces coated with ceramic coating become much easier to clean, allowing dirt and stains to be effortlessly removed with a light wash or regular cleaning due to particles not adhering strongly to the coated surface. Generally, vehicle coatings offer long-lasting durability, with proper maintenance, these protective layers can endure for several years before requiring reapplication."
                : "Permukaan yang dilapisi dengan coating keramik menjadi jauh lebih mudah untuk dibersihkan. Kotoran dan noda dapat dengan mudah dihilangkan dengan cuci ringan atau pembersihan rutin, karena partikel-partikel tidak melekat kuat pada permukaan yang telah dilapisi. Coating kendaraan biasanya memiliki daya tahan yang lama. Dengan perawatan yang baik, lapisan pelindung ini dapat bertahan selama beberapa tahun sebelum perlu dilakukan perawatan ulang."}
            </p>
          </div>
        </section>
        {/*Purpose*/}
        <section className="step-section">
          <div className="step-content">
            <h2 className="roleway">
              {localStorage.getItem("bahasa") === "ing" ? "Purpose" : "Tujuan"}
            </h2>
            <p className="nunito">
              {localStorage.getItem("bahasa") === "ing"
                ? "The primary purpose of using car and motorcycle coatings is to safeguard the vehicle's surface from damage, scratches, corrosion, UV rays, dirt, and other environmental factors. These protective layers create a barrier between the vehicle's surface and elements that can harm it, thus preserving its aesthetic appearance and maintaining the vehicle's condition for an extended period."
                : "Tujuan utama dari penggunaan coating mobil dan motor adalah untuk melindungi permukaan kendaraan dari kerusakan, goresan, korosi, sinar UV, kotoran, dan faktor lingkungan lainnya. Lapisan pelindung ini mampu membentuk penghalang antara permukaan kendaraan dan elemen-elemen yang dapat merusaknya, sehingga menjaga tampilan estetika dan mempertahankan kondisi kendaraan dalam jangka waktu yang lebih lama."}
            </p>
          </div>
        </section>
        {/*Pricing Packages*/}
        <section className="step-section" style={{ flexDirection: 'column', backgroundColor: '#fcfcfc', padding: '60px 0' }}>
          <h2 className="roleway text-center mb-4">
            {localStorage.getItem("bahasa") === "ing" ? "Pricing Detail" : "Daftar Harga"}
          </h2>
          <div className="d-flex justify-content-center mb-5">
            <ButtonGroup>
              <Button
                variant={activeTab === "detailing" ? "danger" : "outline-danger"}
                onClick={() => setActiveTab("detailing")}
                style={{ fontWeight: "bold", padding: "10px 30px" }}
              >
                Detailing
              </Button>
              <Button
                variant={activeTab === "coating" ? "danger" : "outline-danger"}
                onClick={() => setActiveTab("coating")}
                style={{ fontWeight: "bold", padding: "10px 30px" }}
              >
                Coating
              </Button>
            </ButtonGroup>
          </div>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "30px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexWrap: "wrap",
              width: "100%"
            }}
          >
            {(activeTab === "coating" ? coating_prices : detailing_prices).map((item, index) => {
              return (
                <Card
                  style={{
                    padding: "0px",
                    border: "none",
                    borderRadius: "3px",
                    maxWidth: "320px",
                    width: "100%",
                    boxShadow: "10px 10px 15px -3px rgba(255, 0, 0, 0.4)",
                  }}
                  key={index}
                >
                  <Card.Body
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "30px",
                    }}
                  >
                    <h2 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0px" }} className="price-title">
                      {item.title}
                    </h2>
                    <h4 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0px", textDecoration: "line-through" }} className="price-title">
                      {item.Bprice}
                    </h4>
                    <Card.Title style={{ textAlign: "center", fontWeight: "bolder", fontSize: "30px" }} className="price-title text-danger">
                      {item.price}
                    </Card.Title>
                    <Button
                      className="price-card-button"
                      href={item.massage}
                      target="_blank"
                    >
                      {localStorage.getItem("bahasa") === "ing" ? "Book Now!!" : "Booking Sekarang!!"}
                    </Button>
                    <Card.Subtitle className="mb-3 mt-2 text-muted" style={{ textAlign: "center", fontWeight: "bold" }}>
                      {item.type}
                    </Card.Subtitle>
                    <ListGroup className="list-group-flush list-tawaran">
                      {item.steps.map((materi, i) => (
                        <ListGroup.Item key={i} style={{ border: 'none', background: 'transparent' }}>{materi}</ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Card.Body>
                </Card>
              );
            })}
          </Row>
        </section>
      </div>
      <Footer />

      <Helmet>
        <meta name={metaData.name} content={metaData.content} />
      </Helmet>
    </>
  );
};

export default Coatingpage;
